import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import UploadModules from "../../constants/uploadModules";
import teamMemberService from "../../services/teamMember/teamMemberService";

export default function TeamMemberForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        memberName: "",

        designation: "",

        qualification: "",

        description: "",

        photo: "",

        linkedInUrl: "",

        displayOrder: 0,

        isActive: true

    });


    useEffect(() => {

        if (isEdit) {

            loadTeamMember();

        }

    }, [isEdit]);


    const loadTeamMember = async () => {

        try {

            setLoading(true);

            const response = await teamMemberService.getById(id);

            if (response.success) {

                const data = response.data;

                setForm({

                    memberName: data.memberName || "",

                    designation: data.designation || "",

                    qualification: data.qualification || "",

                    description: data.description || "",

                    photo: data.photo || "",

                    linkedInUrl: data.linkedInUrl || "",

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Failed to load team member.");

        }
        finally {

            setLoading(false);

        }

    };


    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox"
                ? checked
                : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!form.memberName.trim()) {

            toast.error("Member Name is required.");

            return;

        }


        try {

            setLoading(true);

            let response;


            if (isEdit) {

                response = await teamMemberService.update(
                    id,
                    form
                );

            }
            else {

                response = await teamMemberService.create(
                    form
                );

            }


            if (response.success) {

                toast.success(response.message);

                navigate("/team-members");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>

                    {isEdit
                        ? "Edit Team Member"
                        : "Add Team Member"}

                </h2>

            </div>


            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">


                            {/* Member Name */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Member Name

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="memberName"
                                    value={form.memberName}
                                    onChange={handleChange}
                                    placeholder="Enter member name"
                                />

                            </div>


                            {/* Designation */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Designation

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="designation"
                                    value={form.designation}
                                    onChange={handleChange}
                                    placeholder="e.g. Chief Cardiologist"
                                />

                            </div>


                            {/* Qualification */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Qualification

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="qualification"
                                    value={form.qualification}
                                    onChange={handleChange}
                                    placeholder="e.g. MBBS, MD (Cardiology)"
                                />

                            </div>


                            {/* LinkedIn URL */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    LinkedIn URL

                                </label>

                                <input
                                    type="url"
                                    className="form-control"
                                    name="linkedInUrl"
                                    value={form.linkedInUrl}
                                    onChange={handleChange}
                                    placeholder="https://www.linkedin.com/in/..."
                                />

                            </div>


                            {/* Description */}

                            <div className="col-lg-8">

                                <label className="form-label">

                                    Description

                                </label>

                                <textarea
                                    rows="5"
                                    className="form-control"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    placeholder="Enter team member description"
                                />

                            </div>


                            {/* Display Order */}

                            <div className="col-lg-4">

                                <label className="form-label">

                                    Display Order

                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Photo */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Photo

                                </label>

                                <ImageUploader
                                    module={UploadModules.TEAM}
                                    value={form.photo}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            photo: path
                                        })
                                    }
                                />

                            </div>


                            {/* Status */}

                            <div className="col-lg-6 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >

                                        Active

                                    </label>

                                </div>

                            </div>


                        </div>


                        <hr />


                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() =>
                                    navigate("/team-members")
                                }
                            >

                                Cancel

                            </button>


                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >

                                {
                                    loading
                                        ? "Saving..."
                                        : isEdit
                                            ? "Update"
                                            : "Save"
                                }

                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </AdminLayout>

    );

}